<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/QC/QCCheckIn'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fas fa-search-location"></i>
            </span>
            <h3 class="kt-portlet__head-title">เช็คอินร้านค้า</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="chlKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อ-สกุลผู้เช็คอิน คะแนนรวม"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>วันที่เช็คอิน :</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="วันที่เช็คอิน (วว/ดด/ปปปป)"
                      id="chlCheckInDate"
                      name="chlCheckInDate"
                      ref="chlCheckInDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่าย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'chlShopIds'"
                    :name="'chlShopIds'"
                    :select2-options="chlShopIdsOptions"
                    v-model="chlShopIds"
                    ref="chlShopIdsSelect2"
                    multiple
                  ></select2>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'chlSubShopIds'"
                    :name="'chlSubShopIds'"
                    :select2-options="chlSubShopIdsOptions"
                    v-model="chlSubShopIds"
                    ref="chlSubShopIdsSelect2"
                    multiple
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="checkInTable"
              >
                <thead>
                  <tr>
                    <th class="all" width="10%">วันที่เช็คอิน</th>
                    <th class="all" width="15%">ชื่อ-สกุลผู้เช็คอิน</th>
                    <th class="all" width="10%">คะแนนรวม</th>
                    <th class="all" width="15%">ประเภทร้านค้า</th>
                    <th class="all" width="15%">ร้านค้า</th>
                    <th class="all" width="15%">ร้านค้า 2</th>
                    <th width="15%" class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="detailCheckIn" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
  </div>`,
  methods: {
    detailCheckIn: function() {
      router.push({
        path: `/QC/QCCheckIn/Detail/${this.data.checkInItemId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;

    return {
      chlKeyword: null,
      chlCheckInDate: null,
      chlShopIds: [],
      chlShopIdsOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/QCFilterShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

      chlSubShopIds: [],
      chlSubShopIdsOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/QCFilterSubShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
              ParentShopCodes: self.chlShopIds || [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.chlKeyword = null;
      self.chlCheckInDate = null;

      $("#chlCheckInDate")
        .val("")
        .trigger("change");

      $("#chlShopIds")
        .val("")
        .trigger("change");

        $("#chlSubShopIds")
        .val("")
        .trigger("change");

      self.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#checkInTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#checkInTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.chlCheckInDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.chlCheckInDate).on("changeDate", function(e) {
      self.chlCheckInDate = moment(e.date);
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#checkInTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QICheckIn/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            //check for clear date value
            var idDate = $("#chlCheckInDate").val();
            if (idDate == null || idDate == "") self.chlCheckInDate = null;

            let jsonSearch = {
              SearchKeyword: self.chlKeyword,
              CheckInDate:
                self.chlCheckInDate != null
                  ? self.chlCheckInDate.format("DD/MM/YYYY")
                  : self.chlCheckInDate,
              ShopIds: self.chlShopIds,
              SubShopIds: self.chlSubShopIds,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "desc"]],
        columns: [
          {
            data: "checkInDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.checkInDateFormat;
            },
          },
          { data: "checkInByUserFullName", className: "text-center" },
          {
            data: "totalScore",
            className: "text-center",
          },
          {
            data: "shopTypeCode",
            className: "text-center",
            render: function(data, type, full, meta) {
              return (full.shopTypeCode == "AGENT") ? "ร้านค้าตัวแทนจำหน่าย" : "ร้านค้าตัวแทนจำหน่ายย่อย";
            },
          },
          { data: "displayShopName", className: "text-center" },
          { data: "displayShopName2", className: "text-center" },
          {
            data: "checkInItemId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          //console.log(data);
          if (data && data.checkInItemId) {
            data.showDetailButton = self.$root.canShow([
              "ADMIN_QI",
              "MANAGER_QI",
              "USER_QI",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/QICheckIn/CheckInList.vue